import script from "./EffectsControlPanelToggle.vue?vue&type=script&setup=true&lang=ts"
export * from "./EffectsControlPanelToggle.vue?vue&type=script&setup=true&lang=ts"

import "./EffectsControlPanelToggle.vue?vue&type=style&index=0&id=103324e0&lang=scss"

const __exports__ = script;

export default __exports__